(function() {
  var STAGING = "TCL CA TEST";
  var BRAND = "TCL Canada";
  var HOME = "TCL Canada | TVs, Sound Bars, Phones, Appliances";
  function clean(t) {
    if (!t) return t;
    t = t.replace(new RegExp(STAGING, "g"), BRAND);
    while (t.indexOf(BRAND + " | " + BRAND) >= 0) {
      t = t.replace(BRAND + " | " + BRAND, BRAND);
    }
    if (t.trim() === BRAND) t = HOME;
    return t;
  }
  function fix() {
    document.title = clean(document.title);
    var og = document.querySelector("meta[property=\"og:title\"]");
    if (og) og.content = clean(og.content);
  }
  fix();
  document.addEventListener("DOMContentLoaded", fix);
  var titleEl = document.querySelector("title");
  if (titleEl) {
    new MutationObserver(fix).observe(titleEl, {childList:true,subtree:true,characterData:true});
  }
  [100,300,600,1200].forEach(function(d){setTimeout(fix,d);});
})();